module.exports = __webpack_public_path__ + "static/media/junior.bf01eb7a.png";